import { render, staticRenderFns } from "./brightExhibitor.vue?vue&type=template&id=0d7bcdfb&scoped=true&"
import script from "./brightExhibitor.vue?vue&type=script&lang=js&"
export * from "./brightExhibitor.vue?vue&type=script&lang=js&"
import style0 from "./brightExhibitor.vue?vue&type=style&index=0&id=0d7bcdfb&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7bcdfb",
  null
  
)

export default component.exports